import { Brick, Config, Predicate, Query, registerBrick, WorkflowObjectState, Transaction, ErrorFlow } from 'olympe';
import { getLogger } from '@olympeio/core';
import BCP from './DM_BCP.js';
import { BCP_WORKFLOW_STATES } from './BcpWorkflowAuthorizations';
import { executeLambda } from "../../node/BackendData/LambdaExecutor";
import { generatePsEmailContents } from "./PSEmailTemplate.js";
import { sleep } from "../utils/CommonUtil.js"


export default class PSEmail extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} sendEmail
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update($, [sendEmail], [forwardEvent, setErrorFlow]) {
        try {
            getLogger('PSEmail').info(`PSEmail - Started at ${new Date(Date.now()).toISOString()}`);

            // Get the all BP state request
            let queryBCPState = Query.instancesOf(BCP).andReturn()
                .follow(WorkflowObjectState.currentObjectRel.getInverse())
                .filter(Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP)).andReturn()
            try {
                const queryResult = await queryBCPState.execute()
                const bpBCPRequests = queryResult.toArray();
                const workflowState = BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP

                // send BCP request for BP state to generate or send email for Initiated for PS
                await this.getBCPRequestData(bpBCPRequests, workflowState, sendEmail, $, setErrorFlow)
            } catch (error) {
                getLogger('PSEmail').error(`: Could not send email for the query execute error: ${error}`);
                setErrorFlow(ErrorFlow.create(`: Could not send email for the query execute error: ${error}`, 400))
            }
        }
        catch (error) {
            getLogger('PSEmail').error(`: Could not send email for the error: ${error}`);
            setErrorFlow(ErrorFlow.create(`: Could not send email for the error: ${error}`, 400))
        }
        finally {
            forwardEvent();
        }

    }
    //Generate email template for request and send email
    getObjectEntries = async (BCPGroup, workflowstate, sendEmail, $, setErrorFlow) => {
        if (Object.entries(BCPGroup).length > 0) {
            let indexA = 0;
            for (const [key, value] of Object.entries(BCPGroup)) {
                indexA++;
                const emailOfUser = key.split(/[:;]/)[1]
                const nameOfUser = key.split(/[:;]/)[0]
                const blacklist = Config.getParameter('emailBlacklist') || [];
                if (!blacklist.includes(emailOfUser?.toLowerCase())) {
                    if (emailOfUser != undefined) {
                        //generate the Email template for the particular bcp request
                        let emailBody = await generatePsEmailContents(nameOfUser, value, $);
                        getLogger('PSEmail').info("PSEmail - Email body", emailBody);
                        const t = new Transaction(true);
                        try {
                            console.log(`Before sending PS email to ${emailOfUser}`);
                            
                            if ((indexA + 1) % 100 === 0) {
                                await sleep(2000);
                            }
                            await executeLambda($, sendEmail, [emailOfUser, "BCP request - PS notification", emailBody]);
                            await t.execute();

                            getLogger('PSEmail').info(`PSEmail - Sent email to ${emailOfUser}`);
                        }
                        catch (error) {
                            // Handle errors during the send email process
                            getLogger('PSEmail').error(`error sending BCP email :${emailOfUser} with reason : ${error?.message}`);
                            setErrorFlow(ErrorFlow.create(`error sending BCP email :${emailOfUser} with reason : ${error?.message}`, 400));
                        }
                    }
                    else {
                        getLogger('PSEmail').error(`Email is undefined`);
                    }
                } else {
                    getLogger('PSEmail').error(`Email ${emailOfUser} was ignored by the blacklist`);
                    setErrorFlow(ErrorFlow.create(`error sending BCP email :${emailOfUser} with reason : It is blacklisted email id`, 400));
                }
            }
        }

        getLogger('PSEmail').info(`PSEmail - Completed at ${new Date(Date.now()).toISOString()}`);
    }

    //grouping the bcp object
    groupBcpByPS = (bcp, workflowObject, BCPGroupbyPS, prop) => {
        // Grouping the PS Object and send the actual object containing bcp and workflowstate object
        if (!BCPGroupbyPS[prop]) {
            BCPGroupbyPS[prop] = [];
        }
        let actualBCPObject = [bcp, workflowObject];
        BCPGroupbyPS[prop].push({
            actualBCPObject
        });
    }

    // pass the query result data to send the bcp request for email sending for PS 
    getBCPRequestData = async (bpBCPRequests, workflowState, sendEmail, $, setErrorFlow) => {
        const BCPGroupbyPS = [];

        if (bpBCPRequests?.length > 0) {
            for (const [bcp, workflowObject] of bpBCPRequests) {

                const psProp = bcp.get(BCP.procurementSpecialistProp)
                const notificationStage = bcp.get(BCP.notification_stageProp)

                if ((
                        notificationStage !== BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP && 
                        notificationStage !== BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM && 
                        notificationStage !== BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE && 
                        notificationStage !== BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1 && 
                        notificationStage !== BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2
                    )
                    && 
                        notificationStage === null && psProp
                ) {

                    if (psProp !== null || undefined) {
                        const prop = psProp                        
                        // Grouping the bcp object
                        this.groupBcpByPS(bcp, workflowObject, BCPGroupbyPS, prop)
                    }
                }

            }
        }

        // generate the email body and send email for PS
        await this.getObjectEntries(BCPGroupbyPS, workflowState, sendEmail, $, setErrorFlow)
    }
}

registerBrick('0198896a7f198611ff08', PSEmail);
